import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { RadioButton } from 'primeng/radiobutton';
import { CapturumValidatorComponent } from '@capturum/ui/api';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-radio-input',
  templateUrl: './radio-input.component.html',
  imports: [RadioButton, CapturumValidatorComponent, ReactiveFormsModule, AsyncPipe],
})
export class RadioInputComponent extends FieldType implements OnInit {
  public selectedValue: any = null;

  public ngOnInit(): void {
    this.selectedValue = this.formControl.value;
  }
}
